import { render, staticRenderFns } from "./UserInvoice.vue?vue&type=template&id=96f2b354&scoped=true&"
import script from "./UserInvoice.vue?vue&type=script&lang=js&"
export * from "./UserInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f2b354",
  null
  
)

export default component.exports